export { default as offsetFrom } from "./offsetFrom.js"
